
import Cell from 'vux/src/components/cell/index.vue'

import { store } from "@/observable/store";
import UserInfoToast from "@/components/toast/userInfo";
import { customer } from "@/utils/customer/index.js";

export default {
props: ["accountRule"],
data() {
return {
serviceIconUrl: "",
serviceData: null,
};
},
components: {
Cell,
UserInfoToast,
},
created() {
this.getServiceData();
},
computed: {
uid() {
return store.uid;
},
channelCommodityCode() {
return this.$route.query.channelCommodityCode;
},
},
methods: {
onServiceClick() {
this.$emit("custUrlClick");
customer.serverDataHandler(this.serviceData);
},
getServiceData() {
customer.severData(this.channelCommodityCode).then((res) => {
if (res && res.serviceType == 1) {


this.serviceIconUrl =
"https://static.soyoung.com/sy-pre/service_by_phone-1675242600669.png";
} else {
this.serviceIconUrl =
"https://static.soyoung.com/sy-pre/kefu-1606813800719.png";
}
this.serviceData = res;
});
},
btnClick() {
if (this.uid != 0) {
this.goPay();
} else {
this.$refs.userlogin.showoast();
}
},
goPay() {
this.$emit("btnClick");
},
loginCallback() {
this.$emit("loginCallback");
},
},
};
